import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../provider/auth";

export default function PrivateRoute({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
